import {StyleParamType, createStylesParams} from '@wix/tpa-settings'

import {
  Alignment,
  AlignmentStringToNumber,
  ImageSize,
  ImageSizeStringToNumber,
} from '../../../../../types/createStylesParams'

export type LayoutStylesParams = {
  layoutSpaceBetweenExperiences: StyleParamType.Number
  maximumExperiencesPerRow: StyleParamType.Number
  breadcrumbsAlignment: StyleParamType.Number
  titleAlignment: StyleParamType.Number
  experienceTextAlignment: StyleParamType.Number
  experienceButtonAlignment: StyleParamType.Number
  fitLocationTabsWidthToListWidth: StyleParamType.Number
  locationTabsAlignment: StyleParamType.Number
  experienceImageSize: StyleParamType.Number
}

export const layoutStylesParams = createStylesParams<LayoutStylesParams>({
  layoutSpaceBetweenExperiences: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: (params) => (params.isMobile ? 20 : 32),
  },
  maximumExperiencesPerRow: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: (params) => (params.isMobile ? 1 : 3),
  },
  breadcrumbsAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => AlignmentStringToNumber[Alignment.Left],
  },
  titleAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => AlignmentStringToNumber[Alignment.Center],
  },
  experienceTextAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => AlignmentStringToNumber[Alignment.Center],
  },
  experienceButtonAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => AlignmentStringToNumber[Alignment.Center],
  },
  fitLocationTabsWidthToListWidth: {
    type: StyleParamType.Number,
    getDefaultValue: (params) => (params.isMobile ? 1 : 0),
  },
  locationTabsAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => AlignmentStringToNumber[Alignment.Center],
  },
  experienceImageSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => ImageSizeStringToNumber[ImageSize.Fit],
  },
})
